<template>
    <div class="">
        <ctlHomeNav></ctlHomeNav>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>     
        <v-container fluid >
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Find My Rep</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ctlSalesRepSearchFilter @onSearchParamsChanged="onSearchParamsChanged"></ctlSalesRepSearchFilter>
                    </v-card-text>
                    <v-card-text v-if="items.length">
                        <ctlSalesRepSearchCardView 
                            :items="items"
                            ></ctlSalesRepSearchCardView>
                        <!-- <ctlItemAdvancedSearchTableView 
                            class="hidden-xs-only"
                            :items="items"
                            @onItemPicked="viewQuote"
                            ></ctlItemAdvancedSearchTableView> -->

                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- {{userData}} -->
    </div>


</template>
<script>
// import _ from 'lodash'
// import jobTypeApi from '@/api/jobTypeApi'
import ctlSalesRepSearchFilter from '@/components/hmTerrAssignDb/ctlSalesRepSearchFilter'
// import ctlItemAdvancedSearchTableView from '@/components/ctlItemAdvancedSearchTableView'
import ctlSalesRepSearchCardView from '@/components/hmTerrAssignDb/ctlSalesRepSearchCardView'
import ctlHomeNav from '@/components/ctlHomeNav'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlSalesRepSearchFilter': ctlSalesRepSearchFilter,
        // 'ctlItemAdvancedSearchTableView': ctlItemAdvancedSearchTableView,
        'ctlSalesRepSearchCardView': ctlSalesRepSearchCardView,
        'ctlHomeNav': ctlHomeNav
        },
    data: () => ({
        searchCriteria: {
            // statusSelected: [1, 5],
            // jobTypeSelected: 0
        },
        pages: null,
        items: [],

    }),
    computed: {
        itemPicked(item) {
            //do nothing now
        },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        searchCriteria: {
            handler: async function (newVal, oldVal) {
                console.log(`${newVal.page} === ${oldVal.page}`)
                // if page not changes, it means the search fired from other search filters
                // so I need reset page = 1
                if(oldVal && newVal.page === oldVal.page) {
                    // newVal.page = 1
                }
                await this.searchItems()
            },
            deep: true
        },
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('tazApi',[
            'searchRepsForWebQuote'
        ]),
        async onSearchParamsChanged (paras) {
            this.searchCriteria = Object.assign({}, paras)
            
        },
        async searchItems () {
            // console.log(this.searchCriteria.zip)
            this.items = await this.searchRepsForWebQuote(this.searchCriteria)
            // this.items = searchResult.records
            // this.pages = searchResult.pageCount
            // this.setUserItemAdvancedSearchParams(this.searchCriteria)
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {

    },
    mounted: function () {
        // this.searchItems()
        console.log('this.userHasInternalRole' + this.userHasInternalRole)
        console.log('this.userHasPublicRole' + this.userHasPublicRole)

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>